import React from 'react'

export const MonthPicker = ({onChange}) => {

    const setMonth = (e) => {
        onChange(e.target.value)
    }
  return (
  
        <select name="month" id="month" className="uk-select" onChange={setMonth}>
            <option value="">--Select Month--</option>
            <option value="01">January</option>
            <option value="02">February</option>
            <option value="03">March</option>
            <option value="04">April</option>
            <option value="05">May</option>
            <option value="06">June</option>
            <option value="07">July</option>
            <option value="08">August</option>
            <option value="09">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
        </select>
    
  )
}

export const YearPicker = ({onChange}) => {
    const setYear = (e) => {
        onChange(e.target.value)
    }

    // Get the current year
    const currentYear = new Date().getFullYear();

    // Generate an array of the last 10 years
    const years = Array.from({length: 11}, (_, i) => currentYear - i);

    return (
        <div>
            <select name="year" id="year" className="uk-select" onChange={setYear}>
                <option value="">--Select Year--</option>
                {years.map(year => <option key={year} value={year}>{year}</option>)}
            </select>
        </div>
    )
}
